module.exports = __webpack_public_path__ + "img/deposit.b771b439.svg";